import script from "./TressTheMyPagesFavorites.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressTheMyPagesFavorites.vue?vue&type=script&lang=ts&setup=true"

import "./TressTheMyPagesFavorites.vue?vue&type=style&index=0&id=40fd382e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40fd382e"]])

export default __exports__